export default (function (node) {
  return node && node.ownerDocument || document;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dom-lib/es/query/ownerDocument.js
// module id = 312
// module chunks = 35